// custom tab button

function convertToClassName(text) {
    return 'avis-' + text.toLowerCase().replace(/\s+/g, '-');
  }
  
  const customTabButton = setInterval(function(){
    let checkOption = document.querySelector(".avpoptions-container__v2");
    let optionContainer = document.querySelector(".apo-customize-group .apo-custom_btn-tab");
  
    if (checkOption && optionContainer) {
      let button = optionContainer.querySelector("label.avp-productoptioncheckwrapper input:checked"); 
      
      let allOptionItems = document.querySelectorAll(".apo-customize-group .avis-tab-item");
      allOptionItems.forEach(item => item.style.display = "none");
  
      if (button) {
        let className = convertToClassName(button.value);
        
        let selectedItems = document.querySelectorAll(`.apo-customize-group .${className}.avp-option`);
        selectedItems.forEach(item => item.style.display = "block");
      }
    }
  }, 100);